import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ICapabilityRequest } from '../../interfaces/ICapabilityRequest';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../services/app-config/app-config.service';
import { IAppConfig } from 'src/app/interfaces/IAppConfig';

/**
 * Class for interacting with function app
 */
@Injectable({
    providedIn: 'root'
})
export class FormService {

    constructor(private _http: HttpClient, private _config: AppConfigService){}

    /**
     * Upload JSON object to function app
     * @param {ICapabilityRequest} request Capability Request object
     * @returns {Observable<any>} Returns Observable containing function app response
     */
    post(request: ICapabilityRequest): Observable<any>{
        return this._http.post((this._config.config).function_app.uri, request, {
            headers: {
                'x-functions-key': (this._config.config).function_app.key
            }
        });
    }
}
